import { Empresa } from ".";

export class Criterio{

    id: number = 0;
    empresaId: number = 0;
    empresa!: Empresa;
    nome: string = "";
    peso: number = 0;
    situacao: string = "A";

    constructor(model?: Criterio){

        if(!model)
            return;

        this.id = model.id;
        this.empresaId = model.empresaId;
        this.empresa = model.empresa;
        this.nome = model.nome;
        this.peso = model.peso;
        this.situacao = model.situacao;
    }
}